import { Component, OnInit } from '@angular/core';
import { API_ENDPOINTS } from '../../constants/api-endpoints.constants';

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrl: './landing.component.scss'
})
export class LandingComponent implements OnInit {
  ngOnInit(): void {
    window.location.href = API_ENDPOINTS.authentication.signIn;
  }
}
